import React, { useEffect } from "react";
import { useToast } from "@chakra-ui/react";
// import { BsCart2 } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  getAllTrendingProduct,
  getNotifyMe,
} from "../../../../Redux/ProductController/action";

function AllTrendingProducts() {
  const toast = useToast();
  const { allTrendingProduct, isLoading } = useSelector(
    (store) => store.prodReducer
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllTrendingProduct());
  }, [dispatch]);
  const notifyMeHandler = (productId) => {
    dispatch(getNotifyMe(productId));
  };

  return (
    <>
      <div className="grid justify-items-center grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {allTrendingProduct &&
          allTrendingProduct?.map((product) => {
            return (
              <div className="max-w-sm mx-5 my-3 rounded-lg border-[1px] bg-white border-[#e2e8f0] shadow-lg xl:max-w-md lg:m-3">
                <Link to={`/productDetails/${product?.productId?.productId}`}>
                  <div className="relative">
                    <div className="max-w-sm xl:max-w-md">
                      <img
                        className="rounded-t-lg"
                        src={product?.productId?.img}
                        alt={product?.productId?.productName}
                      />
                    </div>
                    <div className="p-[0.5em]">
                      <div className="flex justify-between items-center w-full text-left">
                        <h1 className="font-semibold">
                          {product?.productId?.productName}
                        </h1>
                        <div>
                          {product?.productId?.isAllVariantSoldOut ? (
                            <button
                              className="bg-[#F52E7D] hover:bg-[#ee70a3] text-[13px] font-semibold text-[white] py-1.5 px-2.5 rounded-md"
                              onClick={(e) => {
                                e.preventDefault();
                                toast({
                                  title:
                                    "We will notify you, when the product is available",
                                  status: "success",
                                  duration: 3000,
                                  position: "top",
                                  isClosable: true,
                                });
                                notifyMeHandler(product?.productId?.productId);
                              }}
                            >
                              Notify Me
                            </button>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className="flex items-start w-full text-left justify-between py-1">
                        <div className="flex gap-2">
                          <p className="line-through">
                            ₹{product?.productId?.priceDetails?.price}
                          </p>
                          <p className="font-bold">
                            ₹{product?.productId?.priceDetails?.sellingPrice}
                          </p>
                        </div>
                        {/* <div
                          className="flex justify-center items-center w-[2em] h-[2em] rounded-full bg-slate-300 hover:bg-slate-200"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          <BsCart2 size={16} />
                        </div> */}
                      </div>
                    </div>
                    {product?.productId?.isAllVariantSoldOut ? (
                      <div className="absolute bg-[black] px-3 py-[3px] top-1 left-1 rounded-md">
                        <p className="text-[13px] font-bold text-white">
                          {"Sold Out"}
                        </p>
                      </div>
                    ) : (
                      <div className="absolute bg-[#1E9C99] px-3 py-[3px] top-1 left-1 rounded-md">
                        <p className="text-[13px] font-bold text-white">{`${product?.productId?.priceDetails?.discountPercentage}% Off`}</p>
                      </div>
                    )}
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    </>
  );
}

export default AllTrendingProducts;
